// extracted by mini-css-extract-plugin
export var arrowsContainer = "v3-text-carousel-module--arrowsContainer--bd623";
export var backgroundSvg = "v3-text-carousel-module--backgroundSvg--c368d";
export var carousel = "v3-text-carousel-module--carousel--acb40";
export var carouselElt = "v3-text-carousel-module--carouselElt--f8160";
export var container = "v3-text-carousel-module--container--aa390";
export var content = "v3-text-carousel-module--content--d76c4";
export var text = "v3-text-carousel-module--text--36dfd";
export var title = "v3-text-carousel-module--title--2ac23";